import { View, Text } from '@react-pdf/renderer';
import theme from '../../../theme';
import { PdfDocumentProps } from './ExportPdf';

export type PdfGeneralInfoProps = Pick<PdfDocumentProps, 'caseDetails'>;

const PdfGeneralInfo = ({ caseDetails: data }: PdfGeneralInfoProps) => {
    return (
        <>
            {data && (
                <>
                    {' '}
                    <View style={{ paddingVertical: 3, width: '97%', margin: 'auto' }}>
                        <Text>
                            <Text style={{ fontWeight: 'bold', fontSize: 13 }}>
                                {data?.memberName}{' '}
                            </Text>
                            <Text style={{ fontSize: 11 }}>
                                {data.memberAgeAtSurgery} Years Old
                            </Text>
                        </Text>
                        <Text>{data.memberBmi != null ? '|' + data.memberBmi + ' BMI' : ''}</Text>
                        {data.diagnosis.map((item, i) => (
                            <Text style={{ display: 'flex', fontSize: 8 }} key={i}>
                                {item}
                            </Text>
                        ))}
                    </View>
                    <View
                        style={{
                            padding: 5,
                            border: '2px solid black',
                            borderColor: theme.palette.appBackground.main,
                            width: '97%',
                            margin: 'auto',
                            borderRadius: '10',
                            fontSize: 8
                        }}>
                        <View
                            style={{
                                flexDirection: 'row'
                            }}>
                            <View style={{ width: '33%', padding: 3 }}>
                                <Text style={{ fontWeight: 'bold' }}>
                                    Case Stage:{' '}
                                    <Text style={{ fontWeight: 'normal' }}>{data.caseStage}</Text>
                                </Text>
                            </View>
                            <View style={{ width: '33%', padding: 3 }}>
                                <Text style={{ fontWeight: 'bold' }}>
                                    LOB: <Text style={{ fontWeight: 'normal' }}>{data.lob}</Text>
                                </Text>
                            </View>
                            <View style={{ width: '33%', padding: 3 }}>
                                <Text style={{ fontWeight: 'bold' }}>
                                    Date of Service:{' '}
                                    <Text style={{ fontWeight: 'normal' }}>
                                        {new Date(data?.startDateOfService).toLocaleDateString()}
                                    </Text>
                                </Text>
                            </View>
                        </View>
                        <View
                            style={{
                                flexDirection: 'row'
                            }}>
                            <View style={{ width: '33%', padding: 3 }}>
                                <Text style={{ fontWeight: 'bold' }}>
                                    Review Type:{' '}
                                    <Text style={{ fontWeight: 'normal' }}>{data.reviewType}</Text>
                                </Text>
                            </View>
                            <View style={{ width: '33%', padding: 3 }}>
                                <Text style={{ fontWeight: 'bold' }}>
                                    Client:{' '}
                                    <Text style={{ fontWeight: 'normal' }}>{data.payer}</Text>
                                </Text>
                            </View>
                            <View style={{ width: '33%', padding: 3 }}>
                                <Text style={{ fontWeight: 'bold' }}>
                                    Facility Setting:{' '}
                                    <Text style={{ fontWeight: 'normal' }}>
                                        {data.facilitySetting}
                                    </Text>
                                </Text>
                            </View>
                        </View>
                        <View
                            style={{
                                flexDirection: 'row'
                            }}>
                            <View style={{ width: '33%', padding: 3 }}>
                                <Text style={{ fontWeight: 'bold' }}>
                                    Clinical Service:{' '}
                                    <Text style={{ fontWeight: 'normal' }}>
                                        {data.clinicalService}
                                    </Text>
                                </Text>
                            </View>
                            <View style={{ width: '33%', padding: 3 }}>
                                <Text
                                    style={{
                                        fontWeight: 'bold',
                                        color: data.providerFlagged ? 'red' : 'black'
                                    }}>
                                    Requesting Provider:{' '}
                                    <Text style={{ fontWeight: 'normal' }}>
                                        {data.requestingProvider}
                                    </Text>
                                </Text>
                            </View>
                            <View style={{ width: '33%', padding: 3 }}>
                                <Text style={{ fontWeight: 'bold' }}>
                                    Flagged Reasoning:{' '}
                                    <Text style={{ fontWeight: 'normal' }}>
                                        {data.providerFlaggedReason}
                                    </Text>
                                </Text>
                            </View>
                        </View>
                    </View>
                </>
            )}
        </>
    );
};

export default PdfGeneralInfo;
